module.exports = __webpack_public_path__ + "img/ETH_Icon.f676b364.png";